import { z } from "zod";
import { TranslationSchema } from "@/utils/i18n";

export namespace CookieConsent {
  /**
   * Гео-зона по CF-IPCountry:
   * - gdpr — ЕС/ЕЭЗ, UK, CH, а также неизвестная страна (XX) и Tor (T1): строгий opt-in;
   * - row — остальной мир: notice, аналитика включена по умолчанию (opt-out).
   */
  export const ZoneSchema = z.enum(["gdpr", "row"]);

  export type Zone = z.infer<typeof ZoneSchema>;

  /**
   * Контракт с бэкендом: `window.cookieConsentConfig` на всех страницах.
   * Если конфига нет — работаем в самом строгом режиме (gdpr) с английскими текстами.
   */
  export const ConfigSchema = z.object({
    zone: ZoneSchema,
    country: z.string(),
    privacyUrl: z.string(),
    translation: TranslationSchema,
  });

  export type Config = z.infer<typeof ConfigSchema>;

  /**
   * - choice — явный выбор (Accept all / Reject / Save preferences);
   * - notice — «Got it» в row-зоне, в gdpr-зоне согласием не считается.
   */
  export type Method = "choice" | "notice";

  export const StoredSchema = z.object({
    v: z.number(),
    necessary: z.literal(true),
    analytics: z.boolean(),
    advertising: z.boolean(),
    method: z.enum(["choice", "notice"]),
    ts: z.number(),
  });

  export type Stored = z.infer<typeof StoredSchema>;

  export interface State {
    zone: Zone;
    country: string;
    privacyUrl: string;
    /** Текущее решение по категории Analytics (GA4 + Mixpanel). */
    analytics: boolean;
    /** Текущее решение по категории Advertising (ad_storage/ad_user_data/ad_personalization). */
    advertising: boolean;
    /** Выбор сохранён — баннер не показываем. */
    decided: boolean;
    /** Открыто окно Cookie Settings. */
    settings: boolean;
  }
}
